import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Category, PriceLevel } from "../models"
import { MessageActions } from "./message.actions"
import { CombinedPriceLevel } from "../models/ui"
import { UnsafeAction } from "./UnsafeAction"

export interface SaveCategories {
	categoryCollectionUrl: string
	categories: Category[],
	combinedPricelevels: CombinedPriceLevel[]
}

/* tslint:disable */
@Injectable()
export class CategoryActions {

	static CLEAR_STATE = "[Category] Clear State";
	clearState(): Action {
		return {
			type: CategoryActions.CLEAR_STATE
		}
	}

	static LOAD_COLLECTION = '[Category] Load Category';
	loadCollection(url: string): UnsafeAction {
		return {
			type: CategoryActions.LOAD_COLLECTION,
			payload: url
		};
	}

	static LOAD_COLLECTION_SUCCESS = '[Category] Load Collection Success';
	loadCollectionSuccess(categories: Category[]): UnsafeAction {
		return {
			type: CategoryActions.LOAD_COLLECTION_SUCCESS,
			payload: categories
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/actions/category.actions.ts